import React from "react";

import { useTranslation, useUserContext } from "utils";

import { greetingKeyForHour } from "pages/app/home/hero/greeting";

export const HomeGreeting = () => {
  const { t } = useTranslation("home");
  const { user } = useUserContext();
  const greeting = user?.firstName
    ? t(`hero.greeting.${greetingKeyForHour(new Date().getHours())}`, { firstName: user.firstName })
    : t("hero.greeting.welcomeBack");

  return (
    <span className="home-hero-greeting" data-testid="home-hero-greeting">
      {greeting}
    </span>
  );
};
